module.exports = __webpack_public_path__ + "static/pcr-product-48be50de1c117a4d448a164f7f18751c.png";